function icon_close() {
    return (
        <svg className="icon icon_close" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.6856 12.1637L8.51847 6.98582L13.6576 1.83621C14.0767 1.41603 14.0767 0.73491 13.6576 0.314962C13.2383 -0.104987 12.5588 -0.104987 12.1395 0.314962L7.0003 5.46457L1.86137 0.314962C1.44204 -0.104987 0.762527 -0.104987 0.3432 0.314962C-0.0761264 0.735141 -0.0761264 1.41626 0.3432 1.83621L5.48214 6.98582L0.314495 12.1637C-0.104832 12.5839 -0.104832 13.2648 0.314495 13.685C0.524159 13.8951 0.798811 14 1.07369 14C1.34857 14 1.62323 13.8951 1.83289 13.685L7.0003 8.50707L12.1675 13.685C12.3771 13.8951 12.6518 14 12.9267 14C13.2016 14 13.4762 13.8951 13.6859 13.685C14.1047 13.265 14.1047 12.5839 13.6856 12.1637Z" />
        </svg>
    )
}

export default icon_close


